export default [ {
    "id"                            : 78937,
    "season"                        : "Testing",
    "materialType"                  : "Testing",
    "testRequestIdentifier"         : 233,
    "specification"                 : "Testing",
    "nikeMsEndUse"                  : "Testing",
    "testSubmissionType"            : "Testing",
    "itemSpecType"                  : "Testing",
    "submitSmDescription"           : "Testing",
    "labTestState"                  : "PENDING",
    "submitFailureSummary"          : "Testing",
    "suppliedMaterialIdentifier"    : "Testing",
    "nikePPSItemNumber"             : "Testing",
    "nikeMsMaterialItemDescription" : "Testing",
    "suppliedMaterialColor"         : "Testing",
    "nikeSupplierLocation"          : "Testing",
    "responsibleNLO"                : "Testing",
    "lab"                           : "Testing",
    "labReceivedDate"               : "Testing",
    "outOfLabDate"                  : "Testing",
    "testResultsComments"           : "Testing"
},
{
    "id"                            : 78922,
    "season"                        : "Testing2",
    "materialType"                  : "Testing2",
    "testRequestIdentifier"         : 377338,
    "specification"                 : "Testing2",
    "nikeMsEndUse"                  : "Testing2",
    "testSubmissionType"            : "Testing2",
    "itemSpecType"                  : "Testing2",
    "submitSmDescription"           : "Testing2",
    "labTestState"                  : "PENDING",
    "submitFailureSummary"          : "Testing2",
    "suppliedMaterialIdentifier"    : "Testing2",
    "nikePPSItemNumber"             : "Testing2",
    "nikeMsMaterialItemDescription" : "Testing2",
    "suppliedMaterialColor"         : "Testing2",
    "nikeSupplierLocation"          : "Testing2",
    "responsibleNLO"                : "Testing2",
    "lab"                           : "Testing2",
    "labReceivedDate"               : "Testing2",
    "outOfLabDate"                  : "Testing2",
    "testResultsComments"           : "Testing2"
},
{
    "id"                            : 4874874,
    "season"                        : "Testing3",
    "materialType"                  : "Testing3",
    "testRequestIdentifier"         : 1233,
    "specification"                 : "Testing3",
    "nikeMsEndUse"                  : "Testing3",
    "testSubmissionType"            : "Testing3",
    "itemSpecType"                  : "Testing3",
    "submitSmDescription"           : "Testing3",
    "labTestState"                  : "PENDING",
    "submitFailureSummary"          : "Testing3",
    "suppliedMaterialIdentifier"    : "Testing3",
    "nikePPSItemNumber"             : "Testing3",
    "nikeMsMaterialItemDescription" : "Testing3",
    "suppliedMaterialColor"         : "Testing3",
    "nikeSupplierLocation"          : "Testing3",
    "responsibleNLO"                : "Testing3",
    "lab"                           : "Testing3",
    "labReceivedDate"               : "Testing3",
    "outOfLabDate"                  : "Testing3",
    "testResultsComments"           : "Testing3"
},
{
    "id"                            : "37373",
    "season"                        : "Testing",
    "materialType"                  : "Testing",
    "testRequestIdentifier"         : 535534,
    "specification"                 : "Testing",
    "nikeMsEndUse"                  : "Testing",
    "testSubmissionType"            : "Testing",
    "itemSpecType"                  : "Testing",
    "submitSmDescription"           : "Testing",
    "labTestState"                  : "PENDING",
    "submitFailureSummary"          : "Testing",
    "suppliedMaterialIdentifier"    : "Testing",
    "nikePPSItemNumber"             : "Testing",
    "nikeMsMaterialItemDescription" : "Testing",
    "suppliedMaterialColor"         : "Testing",
    "nikeSupplierLocation"          : "Testing",
    "responsibleNLO"                : "Testing",
    "lab"                           : "Testing",
    "labReceivedDate"               : "Testing",
    "outOfLabDate"                  : "Testing",
    "testResultsComments"           : "Testing"
},
{
    "id"                            : 8388,
    "season"                        : "Testing",
    "materialType"                  : "Testing",
    "testRequestIdentifier"         : 432342,
    "specification"                 : "Testing",
    "nikeMsEndUse"                  : "Testing",
    "testSubmissionType"            : "Testing",
    "itemSpecType"                  : "Testing",
    "submitSmDescription"           : "Testing",
    "labTestState"                  : "PENDING",
    "submitFailureSummary"          : "Testing",
    "suppliedMaterialIdentifier"    : "Testing",
    "nikePPSItemNumber"             : "Testing",
    "nikeMsMaterialItemDescription" : "Testing",
    "suppliedMaterialColor"         : "Testing",
    "nikeSupplierLocation"          : "Testing",
    "responsibleNLO"                : "Testing",
    "lab"                           : "Testing",
    "labReceivedDate"               : "Testing",
    "outOfLabDate"                  : "Testing",
    "testResultsComments"           : "Testing"
},
{
    "id"                            : 333,
    "season"                        : "Testing",
    "materialType"                  : "Testing",
    "testRequestIdentifier"         : 6456456,
    "specification"                 : "Testing",
    "nikeMsEndUse"                  : "Testing",
    "testSubmissionType"            : "Testing",
    "itemSpecType"                  : "Testing",
    "submitSmDescription"           : "Testing",
    "labTestState"                  : "PENDING",
    "submitFailureSummary"          : "Testing",
    "suppliedMaterialIdentifier"    : "Testing",
    "nikePPSItemNumber"             : "Testing",
    "nikeMsMaterialItemDescription" : "Testing",
    "suppliedMaterialColor"         : "Testing",
    "nikeSupplierLocation"          : "Testing",
    "responsibleNLO"                : "Testing",
    "lab"                           : "Testing",
    "labReceivedDate"               : "Testing",
    "outOfLabDate"                  : "Testing",
    "testResultsComments"           : "Testing"
},
{
    "id"                            : 38938,
    "season"                        : "Testing",
    "materialType"                  : "Testing",
    "testRequestIdentifier"         : 2336777,
    "specification"                 : "Testing",
    "nikeMsEndUse"                  : "Testing",
    "testSubmissionType"            : "Testing",
    "itemSpecType"                  : "Testing",
    "submitSmDescription"           : "Testing",
    "labTestState"                  : "PENDING",
    "submitFailureSummary"          : "Testing",
    "suppliedMaterialIdentifier"    : "Testing",
    "nikePPSItemNumber"             : "Testing",
    "nikeMsMaterialItemDescription" : "Testing",
    "suppliedMaterialColor"         : "Testing",
    "nikeSupplierLocation"          : "Testing",
    "responsibleNLO"                : "Testing",
    "lab"                           : "Testing",
    "labReceivedDate"               : "Testing",
    "outOfLabDate"                  : "Testing",
    "testResultsComments"           : "Testing"
},
{
    "id"                            : 33443,
    "season"                        : "Testing",
    "materialType"                  : "Testing",
    "testRequestIdentifier"         : 23355677,
    "specification"                 : "Testing",
    "nikeMsEndUse"                  : "Testing",
    "testSubmissionType"            : "Testing",
    "itemSpecType"                  : "Testing",
    "submitSmDescription"           : "Testing",
    "labTestState"                  : "PENDING",
    "submitFailureSummary"          : "Testing",
    "suppliedMaterialIdentifier"    : "Testing",
    "nikePPSItemNumber"             : "Testing",
    "nikeMsMaterialItemDescription" : "Testing",
    "suppliedMaterialColor"         : "Testing",
    "nikeSupplierLocation"          : "Testing",
    "responsibleNLO"                : "Testing",
    "lab"                           : "Testing",
    "labReceivedDate"               : "Testing",
    "outOfLabDate"                  : "Testing",
    "testResultsComments"           : "Testing"
}];


// WEBPACK FOOTER //
// ./src/Components/DefaultData.js